import createRoute from '@widesk-ui/tools/createRoute';

export default createRoute.splitView('/entertainments/:entertainmentId/deliveries/print', 'shop', 'DeliveryPrintSplitView', 'impressions');
